const target = '.anchor-link';
const offset = 0;
const duration = 1000;
jQuery(document).on('ready', function () {
    if (window.location.hash) {
        jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery(window.location.hash).offset().top - offset
        }, duration);
    }
    jQuery(target).on('click', function () {
        if (jQuery(this).is('a')) {
            var anchorLink = jQuery(this).attr('href');
        }
        else {
            var href = jQuery(this).find('a').attr('href');
            var hrefArray = href.split("/");
            var anchorLink = hrefArray[hrefArray.length - 1];
        }
        jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery(anchorLink).offset().top - offset
        }, duration);
    });
});
